var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CommonPanel',{attrs:{"title":"核心数据","needExtra":true}},[_c('span',{staticClass:"asideinfo",attrs:{"slot":"extra"},slot:"extra"},[_vm._v("数据每小时更新："+_vm._s(_vm._f("dataFormat")(new Date())))]),_c('today-data'),_c('realtime-rank')],1)}
var staticRenderFns = []

export { render, staticRenderFns }